import React from 'react';
import classnames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import NewBadge from '@wix/da-ds/pkg/Badges/NewBadge';
import DAProtect from '@wix/da-ds/pkg/Icons/24x24/DAProtect';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import s from './HoverComponent.scss';
var type2image = {
    muro: 'il35_-_muro_v3.svg',
    poll: 'il33_-_poll_v3.svg',
    status: 'il30_-_status_update_v3.svg',
    deviant: 'il29_-_deviation_v3.svg',
    journal: 'il31_-_journal_v3.svg',
    literature: 'il32_-_literature_v3.svg',
    motionBook: 'il34_-_motion_book_v3.svg',
    commission: 'il62_-_commission_v3.svg', // IL6.1
};
var HoverComponent = function (_a) {
    var svg = _a.svg, title = _a.title, context = _a.context, className = _a.className;
    var t = useTranslation().t;
    var showDaProtect = useFlag('da_protect_icon') && svg === 'deviant';
    return (React.createElement("div", { className: classnames(s.root, className) },
        React.createElement("div", { className: classnames(s.container, showDaProtect && s['da-protect-container']) },
            React.createElement("div", { className: s.svg },
                React.createElement("img", { loading: "lazy", src: Url.staticCDNLink("eclipse/popups/hover-component/" + type2image[svg]), alt: svg })),
            React.createElement("div", { className: s.title }, t(title)),
            React.createElement("div", { className: s.context }, t(context)),
            showDaProtect && (React.createElement(React.Fragment, null,
                React.createElement(NewBadge, { className: s['da-protect-newbadge'] }),
                React.createElement("div", { className: s['da-protect-heading'] },
                    React.createElement(DAProtect, { className: s['da-protect-icon'] }),
                    t('daProtect.submit.heading')),
                React.createElement("div", { className: s['da-protect-content'] },
                    React.createElement(Trans, { i18nKey: "daProtect.submit.content" },
                        "DeviantArt has your back...",
                        React.createElement("br", null),
                        "Now all new submissions enjoy 3 months protection against art theft on DeviantArt.",
                        React.createElement("a", { href: "https://www.deviantart.com/team/journal/DeviantArt-Protect-Helping-Safeguard-Your-Art-884278903" }, "Learn more"))))))));
};
HoverComponent.displayName = 'HoverComponent';
export default HoverComponent;
//# sourceMappingURL=HoverComponent.js.map